<script setup>
import ContentCenter from '@/layouts/ContentCenter.vue'
</script>

<template>
  <!-- Step 1 -->
  <ContentCenter class="bg-black" />
</template>
